import appConfig from "@/app.config";

const schema = {
  tabs: [
    {
      title: "Product news",
      meta: [{ name: "description", content: appConfig.description }],
      name: "Product news",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: "Add New Product News",
      formData: {},
      schema: {
        name: {
          type: "text",
          label: "News Title",
          placeholder: "Enter News Title",
          required: true,
          info: false,
          character_count: 50,
        },
      },
      side_panel: {
        select_a_page: {
          type: "list",
          label: "Select Product News",
          placeholder: "",
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: "",
          options: [],
        },
      },
      form: {
        title: {
          type: "text",
          label: "News Title",
          placeholder: "Enter News Title",
          required: true,
          info: true,
          character_count: 100,
          disabled: false,
          class: "",
          size: "12",
          style: "",
        },
        description: {
          type: "ckeditor",
          label: "Description",
          placeholder: "Enter Description",
          required: false,
          info: true,
          character_count: 2000,
          disabled: false,
          class: "",
          size: "12",
          style: "",
        },
        date: {
          type: "date",
          label: "Date",
          placeholder: "Enter Date",
          required: true,
          info: true,
          character_count: 0,
          disabled: false,
          class: "",
          size: "6",
          style: "",
        },
        hr1: {
          type: "hr",
          size: "12",
        },
      },
    },
  ],
};

export { schema };
